import { useEffect, useRef, useState } from "react";
import http from "../../config/httpConfig";
import BusinessSettingsService from "../../services/BusinessSettingsService";

// Currency-to-Nationality mapping
const currencyToNationalityMap: Record<string, string> = {
    "৳": "BANGLADESHI",
    "₺": "TURKISH",
    "₹": "INDIAN",
    "रू": "NEPALESE",
    "฿": "THAI",
    "Rp": "INDONESIAN",
    "DH": "MOROCCAN",
    "₱": "FILIPINO"
};

function FormSelect(props: any) {
    const [focused, setFocused] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [options, setOptions] = useState<Array<{ text: string; value: string }>>(props.values || []);

    const selectRef = useRef<HTMLSelectElement | null>(null);

    const { label, errorMessage, onChange, column, id, ajax, mapping, disableFirstOption, ...inputProps } = props;

    const handleFocus = () => {
        setFocused(true);
    };

    const fetchCurrencyAndSetNationality = async () => {
        try {
            // Generate all nationality options first
            const nationalityOptions = Object.values(currencyToNationalityMap).map((nat) => ({
                text: nat.charAt(0).toUpperCase() + nat.slice(1).toLowerCase(),
                value: nat
            }));

            setOptions(nationalityOptions); // Set all nationality options first

            // Fetch currency and get the corresponding nationality
            const response: any = await BusinessSettingsService.find();
            const currencySymbol = response.data.currency;
            const nationality = currencyToNationalityMap[currencySymbol] || "";

            if (nationality && selectRef.current) {
                // Set the selected value in the dropdown
                selectRef.current.value = nationality;

                // Create and dispatch an actual 'change' event
                const event = new Event("change", { bubbles: true });
                selectRef.current.dispatchEvent(event);
            }
        } catch (error) {
            console.error("Error fetching currency:", error);
        }
    };

    const initOptions = () => {
        if (label === "Nationality") {
            fetchCurrencyAndSetNationality();
        } else if (ajax) {
            http.get(mapping?.path)
                .then((response) => {
                    let data: any = [];
                    if (!disableFirstOption) {
                        data.push({ value: "", text: `Select ${label}` });
                    }
                    response.data.forEach((record: any) => {
                        data.push({ value: record[mapping.value], text: record[mapping.text] });
                    });
                    setOptions(data);
                })
                .catch((reason) => {
                    console.error("Error fetching data:", reason);
                });
        } else {
            setOptions(props.values);
        }
        setIsLoaded(true);
    };

    useEffect(() => {
        if (!isLoaded) {
            initOptions();
        }
    }, []);

    return (
        <div className={"mb-1 col-md-" + column}>
            <div style={{ display: "flex", justifyContent: "flex-start" }}>
                <label htmlFor={id}>
                    {label}
                    {inputProps.required && <span style={{ color: "red", marginLeft: "5px" }}>*</span>}
                </label>
            </div>
            <select
                ref={selectRef}
                {...inputProps}
                onChange={onChange}
                onInput={handleFocus}
                focused={focused}
            >
                {options?.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.text}
                    </option>
                ))}
            </select>
            <div className="invalid-feedback">{errorMessage}</div>
        </div>
    );
}

export default FormSelect;
